// import React, { useState, useEffect, useRef } from "react";
// import "./DppScheduling.css";
// import DropDown from "./DropdwonClassic";
// import InputComponent from "../TestScheduling/Input-testscheduling";
// import TextEditor from "./TextEditor";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import SucessImg from "../../../Assets/Images/CommanImages/success.png";
// import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
// import MultiSelectSearchDropdown from "./MultiDropdownClassic";
// import { useLocation, useNavigate } from "react-router-dom";
// import { IoCheckmarkCircle } from "react-icons/io5";
// import { POST } from "../../../Api/HttpsMethods";
// import { GET } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/Endpoints";
// import Colors from "../../../Constants/Colors";
// import Latex from "react-latex";
// import "katex/dist/katex.min.css";
// import he from "he";

// // ─── Truncate a comma-separated list to fit within a character budget ─────────
// // Cuts at the last comma boundary and appends ", ..." so it never breaks mid-word.
// const truncateList = (value, maxChars = 60) => {
//   if (!value) return "";
//   const str = String(value);
//   if (str.length <= maxChars) return str;
//   const cutPoint = str.lastIndexOf(",", maxChars);
//   if (cutPoint <= 0) return str.slice(0, maxChars) + "...";
//   return str.slice(0, cutPoint) + ", ...";
// };

// const DPPSchedulingEdit = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   // All data sent from the dashboard via location.state
//   const dashboardData = location.state || {};
//   const quesPaperId = dashboardData.ques_paper_id;
//   const courseIdFromDashboard = dashboardData.course_id; // numeric e.g. 1

//   console.log("📊 Dashboard data received:", dashboardData);
//   console.log("📋 ques_paper_id:", quesPaperId, "| course_id:", courseIdFromDashboard);

//   useEffect(() => {
//     if (dataClient) {
//       const userName =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);

//   const userName =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";
//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     null;
//   const clientId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
//     sessionStorage.getItem("clientId") ||
//     null;

//   // ── QUESTION PAPER DETAIL state (all read-only display) ──────────────────
//   const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
//   const [selectedQuestionPaperName, setSelectedQuestionPaperName] = useState("");
//   const [selectedQuestionPaperDescription, setSelectedQuestionPaperDescription] = useState("");
//   const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] = useState("");
//   const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] = useState("");
//   const [selectedCourseName, setSelectedCourseName] = useState("");
//   const [selectedCourseId, setSelectedCourseId] = useState("");

//   // Chapter and topic — keep full value for tooltip, truncated for display
//   const [chapterListDisplay, setChapterListDisplay] = useState("");
//   const [chapterListFull, setChapterListFull] = useState("");
//   const [topicListDisplay, setTopicListDisplay] = useState("");
//   const [topicListFull, setTopicListFull] = useState("");

//   // ── Other state ───────────────────────────────────────────────────────────
//   const [selectedChapterId, setSelectedChapterId] = useState([]);
//   const [selectedChapterName, setSelectedChapterName] = useState("");
//   const [selectedTopicId, setSelectedTopicId] = useState([]);
//   const [selectedTopicName, setSelectedTopicName] = useState("");
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [testTemplates, setTestTemplates] = useState([]);
//   const [courses, setCourses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [questionPapers, setQuestionPapers] = useState([]);

//   const [selectedSubjectSupersetId, setSelectedSubjectSupersetId] = useState("");
//   const [selectedSubjectSupersetName, setSelectedSubjectSupersetName] = useState("");
//   const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);

//   // Course Plans
//   const [coursePlans, setCoursePlans] = useState([]);
//   const [coursePlanCardData, setCoursePlanCardData] = useState({});
//   const [expandedCards, setExpandedCards] = useState({});

//   // Folder picker
//   const [folderLevelData, setFolderLevelData] = useState({});
//   const [activeFolderPicker, setActiveFolderPicker] = useState(null);
//   const [expandedLevel1, setExpandedLevel1] = useState(null);
//   const [expandedLevel2, setExpandedLevel2] = useState(null);
//   const [expandedLevel3, setExpandedLevel3] = useState(null);
//   const [folderSearchText, setFolderSearchText] = useState({});
//   const folderPickerRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const [hasAppliedCards, setHasAppliedCards] = useState(false);
//   const [activeCopyDropdown, setActiveCopyDropdown] = useState(null);

//   const [previewData, setPreviewData] = useState(null);
//   const [previewLoading, setPreviewLoading] = useState(false);
//   const [showPreviewPopup, setShowPreviewPopup] = useState(false);
//   const [showOptions, setShowOptions] = useState(false);

//   const copyDropdownRef = useRef(null);

//   // ── Close pickers on outside click ───────────────────────────────────────
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         activeFolderPicker &&
//         folderPickerRef.current &&
//         !folderPickerRef.current.contains(event.target) &&
//         (!dropdownRef.current || !dropdownRef.current.contains(event.target))
//       ) {
//         setActiveFolderPicker(null);
//         setExpandedLevel1(null);
//         setExpandedLevel2(null);
//         setExpandedLevel3(null);
//         setFolderSearchText({});
//       }
//       if (
//         activeCopyDropdown &&
//         copyDropdownRef.current &&
//         !copyDropdownRef.current.contains(event.target)
//       ) {
//         setActiveCopyDropdown(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [activeFolderPicker, activeCopyDropdown]);

//   // ── Populate QUESTION PAPER DETAIL from dashboard data ───────────────────
//   useEffect(() => {
//     if (!dashboardData || !quesPaperId) return;

//     console.log("📝 Populating QUESTION PAPER DETAIL from dashboard data");

//     setSelectedQuestionPaperId(quesPaperId);
//     setSelectedQuestionPaperName(dashboardData.ques_paper_name || "");
//     setSelectedQuestionPaperDescription(dashboardData.ques_paper_desc || ""); // ← from dashboard
//     setSelectedCourseName(dashboardData.course || "");
//     setSelectedQuestionPaperSubjects(dashboardData.subject_name || "");
//     setSelectedQuestionPaperCreatedBy(dashboardData.scheduled_by || "");

//     // Chapter — store full for tooltip, truncated for input display
//     const chapterFull = dashboardData.chapter_list || "";
//     setChapterListFull(chapterFull);
//     setChapterListDisplay(truncateList(chapterFull));

//     // Topic — same treatment (NEW)
//     const topicFull = dashboardData.topic_list || "";
//     setTopicListFull(topicFull);
//     setTopicListDisplay(truncateList(topicFull));

//     // Validate and store course_id early — prevents date string reaching API
//     const numericCourseId = parseInt(courseIdFromDashboard, 10);
//     if (!isNaN(numericCourseId)) {
//       setSelectedCourseId(numericCourseId);
//     } else {
//       console.error("❌ course_id is not a valid number:", courseIdFromDashboard);
//     }
//   }, [dashboardData, quesPaperId]);

//   // ── Fetch existing DPP schedules ─────────────────────────────────────────
//   useEffect(() => {
//     if (!quesPaperId) {
//       console.error("❌ No Question Paper ID provided");
//       return;
//     }
//     const numericQuesPaperId = parseInt(quesPaperId);
//     if (isNaN(numericQuesPaperId)) {
//       console.error("❌ Invalid ques_paper_id:", quesPaperId);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Invalid Question Paper ID. Please return to dashboard and try again.</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       return;
//     }
//     console.log("🔄 Fetching DPP schedules for ques_paper_id:", numericQuesPaperId);
//     fetchDppSchedulesByQuesPaperId(numericQuesPaperId);
//   }, [quesPaperId]);

//   const fetchDppSchedulesByQuesPaperId = async (quesPaperId) => {
//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_SCHEDULE_BY_QUES_PAPER_ID}?ques_paper_id=${quesPaperId}`;
//       console.log("🌐 Full API Call URL:", API_ENDPOINT);

//       const result = await GET.withToken(API_ENDPOINT);
//       console.log("📥 API Response received:", result);

//       if (result?.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
//         const schedules = result.data;
//         const firstSchedule = schedules[0];

//         // Description from API only fills in if dashboard didn't already provide one
//         if (firstSchedule.dpp_desc && !selectedQuestionPaperDescription) {
//           setSelectedQuestionPaperDescription(firstSchedule.dpp_desc);
//         }

//         setInstructionsHtml(firstSchedule.instructions_html || "");

//         // Use the validated numeric course_id from dashboard
//         const numericCourseId = parseInt(courseIdFromDashboard, 10);
//         if (!isNaN(numericCourseId)) {
//           console.log("📚 Using course_id from dashboard:", numericCourseId);
//           setSelectedCourseId(numericCourseId);
//           await fetchCoursePlansForEdit(numericCourseId, schedules);
//         } else {
//           // Last resort: look up by course name
//           console.warn("⚠️ Falling back to course name lookup:", dashboardData.course);
//           if (dashboardData.course) {
//             await fetchCourseIdFromCourseName(dashboardData.course, schedules);
//           }
//         }
//       } else {
//         console.log("ℹ️ No existing schedules — loading empty cards");
//         // Still load course plans so empty cards are shown
//         const numericCourseId = parseInt(courseIdFromDashboard, 10);
//         if (!isNaN(numericCourseId)) {
//           await fetchCoursePlansForEdit(numericCourseId, []);
//         }
//       }
//     } catch (error) {
//       console.error("❌ Error fetching DPP schedules:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Error loading DPP schedule data. Please check console for details.</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     }
//   };

//   const fetchCourseIdFromCourseName = async (courseName, schedules) => {
//     try {
//       const result = await GET.withToken(EndPoints.PRISM_GET_COURSES);
//       if (result?.status === 200 && Array.isArray(result.data)) {
//         const course = result.data.find((c) => c.course_name === courseName);
//         if (course) {
//           console.log("✅ Resolved course_id:", course.course_id, "for:", courseName);
//           setSelectedCourseId(course.course_id);
//           await fetchCoursePlansForEdit(course.course_id, schedules);
//         } else {
//           console.error("❌ Course not found:", courseName);
//         }
//       }
//     } catch (error) {
//       console.error("❌ Error fetching courses:", error);
//     }
//   };

//   const fetchCoursePlansForEdit = async (courseId, existingSchedules) => {
//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${courseId}`;
//       console.log("📚 Fetching course plans from:", API_ENDPOINT);

//       const result = await GET.withToken(API_ENDPOINT);
//       console.log("📚 Course Plans API Response:", result);

//       if (result?.status === 200 && Array.isArray(result.data)) {
//         setCoursePlans(result.data);

//         const folderLevelsPromises = result.data.map((plan) =>
//           fetchFolderLevelsData(plan.course_plan_id)
//         );
//         const allFolderLevels = await Promise.all(folderLevelsPromises);

//         const folderLevelsMap = {};
//         result.data.forEach((plan, index) => {
//           folderLevelsMap[plan.course_plan_id] = allFolderLevels[index];
//         });

//         const initialData = {};
//         const initialExpanded = {};

//         result.data.forEach((plan) => {
//           const matchingSchedule = existingSchedules.find(
//             (s) => s.course_plan_id === plan.course_plan_id
//           );

//           if (matchingSchedule) {
//             let folderPath = "";
//             const planFolderLevels = folderLevelsMap[plan.course_plan_id];

//             if (planFolderLevels && matchingSchedule.dpp_level1_id) {
//               const level1 = planFolderLevels.find(
//                 (l) => l.dpp_level1_id === matchingSchedule.dpp_level1_id
//               );
//               if (level1) {
//                 folderPath = level1.name;
//                 if (matchingSchedule.dpp_level2_id && level1.level2) {
//                   const level2 = level1.level2.find(
//                     (l) => l.dpp_level2_id === matchingSchedule.dpp_level2_id
//                   );
//                   if (level2) {
//                     folderPath += ` > ${level2.name}`;
//                     if (matchingSchedule.dpp_level3_id && level2.level3) {
//                       const level3 = level2.level3.find(
//                         (l) => l.dpp_level3_id === matchingSchedule.dpp_level3_id
//                       );
//                       if (level3) folderPath += ` > ${level3.name}`;
//                     }
//                   }
//                 }
//               }
//             }

//             initialData[plan.course_plan_id] = {
//               dppScheduleId: matchingSchedule.dpp_schedule_id,
//               dppName: matchingSchedule.dpp_name || "",
//               description: matchingSchedule.dpp_desc || "",
//               startDate: matchingSchedule.dpp_window_start
//                 ? matchingSchedule.dpp_window_start.replace(" ", "T").slice(0, 16)
//                 : "",
//               termDate: matchingSchedule.dpp_term_date
//                 ? matchingSchedule.dpp_term_date.replace(" ", "T").slice(0, 16)
//                 : "",
//               folderName: folderPath,
//               folderPath: folderPath,
//               selectedLevel1Id: matchingSchedule.dpp_level1_id,
//               selectedLevel2Id: matchingSchedule.dpp_level2_id,
//               selectedLevel3Id: matchingSchedule.dpp_level3_id,
//               isApplied: true,
//               originalData: { ...matchingSchedule, folderPath },
//               hasChanges: false,
//             };
//             initialExpanded[plan.course_plan_id] = true;
//           } else {
//             initialData[plan.course_plan_id] = {
//               dppName: "",
//               description: "",
//               startDate: "",
//               termDate: "",
//               folderName: "",
//               folderPath: "",
//               selectedLevel1Id: null,
//               selectedLevel2Id: null,
//               selectedLevel3Id: null,
//               isApplied: false,
//               originalData: null,
//               hasChanges: false,
//             };
//             initialExpanded[plan.course_plan_id] = false;
//           }
//         });

//         setCoursePlanCardData(initialData);
//         setExpandedCards(initialExpanded);

//         Object.entries(folderLevelsMap).forEach(([planId, levels]) => {
//           if (levels) {
//             setFolderLevelData((prev) => ({ ...prev, [planId]: levels }));
//           }
//         });
//       } else {
//         console.warn("⚠️ Invalid course plans response:", result);
//       }
//     } catch (error) {
//       console.error("❌ Error fetching course plans:", error);
//     }
//   };

//   const fetchFolderLevelsData = async (coursePlanId) => {
//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_FOLDER_STRUCTURE}?course_plan_id=${coursePlanId}`;
//       const result = await GET.withToken(API_ENDPOINT);
//       if (result?.status === 200 && Array.isArray(result.data)) return result.data;
//       return null;
//     } catch (error) {
//       console.error(`❌ Error fetching folder levels for plan ${coursePlanId}:`, error);
//       return null;
//     }
//   };

//   const fetchFolderLevels = async (coursePlanId) => {
//     try {
//       const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_FOLDER_STRUCTURE}?course_plan_id=${coursePlanId}`;
//       const result = await GET.withToken(API_ENDPOINT);
//       if (result?.status === 200 && Array.isArray(result.data)) {
//         setFolderLevelData((prev) => ({ ...prev, [coursePlanId]: result.data }));
//       }
//     } catch (error) {
//       console.error(`❌ Error fetching folder levels for plan ${coursePlanId}:`, error);
//     }
//   };

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     const fetchTestTemplates = async () => {
//       try {
//         const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_INSTRUCTIONS_TEMPLATE_LIST}?username=${userName}&branch_id=${clientBranchId}`;
//         const data = await GET.withToken(API_ENDPOINT);
//         if (data?.status === 200 && Array.isArray(data.data)) setTestTemplates(data.data);
//         else if (Array.isArray(data)) setTestTemplates(data);
//       } catch (error) {
//         console.error("Error fetching test templates:", error);
//       }
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const data = await GET.withToken(EndPoints.PRISM_GET_COURSES);
//         if (data) setCourses(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       }
//     };
//     fetchCourses();
//   }, []);

//   const updateCardData = (planId, field, value) => {
//     setCoursePlanCardData((prev) => ({
//       ...prev,
//       [planId]: { ...prev[planId], [field]: value, isApplied: false, hasChanges: true },
//     }));
//   };

//   const handleApplyCard = (planId) => {
//     const cardData = coursePlanCardData[planId];
//     if (
//       !cardData.dppName?.trim() ||
//       !cardData.description?.trim() ||
//       !cardData.startDate ||
//       !cardData.folderName
//     ) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>
//               Please fill all required fields: DPP Name, Description, Start Date, and Folder Name.
//             </span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       return;
//     }

//     const currentSnapshot = {
//       dpp_name: cardData.dppName,
//       dpp_desc: cardData.description,
//       dpp_window_start: cardData.startDate,
//       dpp_term_date: cardData.termDate,
//       folderPath: cardData.folderName,
//       dpp_level1_id: cardData.selectedLevel1Id,
//       dpp_level2_id: cardData.selectedLevel2Id,
//       dpp_level3_id: cardData.selectedLevel3Id,
//       dpp_schedule_id: cardData.dppScheduleId,
//     };

//     setCoursePlanCardData((prev) => ({
//       ...prev,
//       [planId]: { ...prev[planId], isApplied: true, originalData: currentSnapshot, hasChanges: true },
//     }));
//     setHasAppliedCards(true);
//   };

//   const handleResetCard = (planId) => {
//     const original = coursePlanCardData[planId]?.originalData;
//     if (original) {
//       const folderPath = original.folderPath || "";
//       setCoursePlanCardData((prev) => ({
//         ...prev,
//         [planId]: {
//           ...prev[planId],
//           dppName: original.dpp_name || "",
//           description: original.dpp_desc || "",
//           startDate: original.dpp_window_start?.replace(" ", "T").slice(0, 16) || "",
//           termDate: original.dpp_term_date?.replace(" ", "T").slice(0, 16) || "",
//           folderName: folderPath,
//           folderPath: folderPath,
//           selectedLevel1Id: original.dpp_level1_id,
//           selectedLevel2Id: original.dpp_level2_id,
//           selectedLevel3Id: original.dpp_level3_id,
//           isApplied: true,
//           hasChanges: false,
//         },
//       }));
//     }
//   };

//   const handleCopyFromPlan = (targetPlanId, sourcePlanId) => {
//     if (!sourcePlanId || sourcePlanId === targetPlanId) return;
//     const sourceData = coursePlanCardData[sourcePlanId];
//     if (sourceData) {
//       setCoursePlanCardData((prev) => ({
//         ...prev,
//         [targetPlanId]: {
//           ...prev[targetPlanId],
//           dppName: sourceData.dppName,
//           description: sourceData.description,
//           startDate: sourceData.startDate,
//           termDate: sourceData.termDate,
//           folderName: sourceData.folderName,
//           folderPath: sourceData.folderPath,
//           selectedLevel1Id: sourceData.selectedLevel1Id,
//           selectedLevel2Id: sourceData.selectedLevel2Id,
//           selectedLevel3Id: sourceData.selectedLevel3Id,
//           isApplied: false,
//           hasChanges: true,
//         },
//       }));
//       setActiveCopyDropdown(null);
//     }
//   };

//   const handleFolderSelect = (planId, level1, level2, level3 = null) => {
//     let folderPath = "";
//     let selectedLevel1Id = null;
//     let selectedLevel2Id = null;
//     let selectedLevel3Id = null;

//     if (level3) {
//       folderPath = `${level1.name} > ${level2.name} > ${level3.name}`;
//       selectedLevel1Id = level1.dpp_level1_id;
//       selectedLevel2Id = level2.dpp_level2_id;
//       selectedLevel3Id = level3.dpp_level3_id;
//     } else if (level2) {
//       folderPath = `${level1.name} > ${level2.name}`;
//       selectedLevel1Id = level1.dpp_level1_id;
//       selectedLevel2Id = level2.dpp_level2_id;
//     }

//     setCoursePlanCardData((prev) => ({
//       ...prev,
//       [planId]: {
//         ...prev[planId],
//         folderName: folderPath,
//         folderPath: folderPath,
//         selectedLevel1Id,
//         selectedLevel2Id,
//         selectedLevel3Id,
//         isApplied: false,
//         hasChanges: true,
//       },
//     }));

//     setActiveFolderPicker(null);
//     setExpandedLevel1(null);
//     setExpandedLevel2(null);
//     setExpandedLevel3(null);
//     setFolderSearchText((prev) => {
//       const s = { ...prev };
//       delete s[planId];
//       return s;
//     });
//   };

//   const toggleFolderPicker = (planId) => {
//     if (activeFolderPicker === planId) {
//       setActiveFolderPicker(null);
//       setExpandedLevel1(null);
//       setExpandedLevel2(null);
//       setExpandedLevel3(null);
//       setFolderSearchText((prev) => {
//         const s = { ...prev };
//         delete s[planId];
//         return s;
//       });
//     } else {
//       setActiveFolderPicker(planId);
//       setExpandedLevel1(null);
//       setExpandedLevel2(null);
//       setExpandedLevel3(null);
//       setFolderSearchText((prev) => ({ ...prev, [planId]: "" }));
//     }
//   };

//   const toggleCardExpanded = (planId) => {
//     setExpandedCards((prev) => ({ ...prev, [planId]: !prev[planId] }));
//   };

//   const handleSave = async () => {
//     const cardsToSave = Object.entries(coursePlanCardData)
//       .filter(([_, data]) => data.isApplied && data.hasChanges)
//       .map(([planId, data]) => ({
//         ques_paper_id: parseInt(selectedQuestionPaperId),
//         dpp_name: data.dppName,
//         dpp_desc: data.description,
//         dpp_abb: "",
//         dpp_window_start: data.startDate ? data.startDate.replace("T", " ") + ":00" : null,
//         dpp_window_end: data.startDate ? data.startDate.replace("T", " ") + ":00" : null,
//         course_plan_id: parseInt(planId),
//         dpp_level1_id: data.selectedLevel1Id,
//         dpp_level2_id: data.selectedLevel2Id,
//         dpp_level3_id: data.selectedLevel3Id || null,
//         subject_superset_id:
//           selectedSubjectIds?.length > 0 ? selectedSubjectIds : null,
//         chapter_names: selectedChapterName || null,
//         topic_names: selectedTopicName || null,
//         dedicated_client_id: clientId ? parseInt(clientId, 10) : null,
//         dpp_term_date: data.termDate ? data.termDate.replace("T", " ") + ":00" : null,
//         instructions_html: instructionsHtml || null,
//         created_by: userName,
//         ...(data.dppScheduleId && { dpp_schedule_id: data.dppScheduleId }),
//       }));

//     if (cardsToSave.length === 0) {
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>No changes to save.</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       return;
//     }

//     // Determine if this is an update (at least one card has an existing dpp_schedule_id)
//     // The API always returns "created" in its message, so we override it on the frontend.
//     const isUpdate = cardsToSave.some((card) => card.dpp_schedule_id);

//     try {
//       const result = await POST.withToken(
//         EndPoints.PRISM_CREATE_DPP_SCHEDULE,
//         cardsToSave,
//         { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
//       );

//       if (result?.status === 200) {
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               {/* Override the API message — it always says "created" even for updates */}
//               <span>
//                 {isUpdate
//                   ? "DPP schedule updated successfully"
//                   : "DPP schedule created successfully"}
//               </span>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(SucessImg);
//         setTimeout(() => navigate(-1), 1000);
//       }
//     } catch (error) {
//       console.error("Error saving DPP schedule:", error);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Error saving DPP schedule</span>
//           </div>
//         </div>
//       );
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     }
//   };

//   const getCurrentDateTime = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     const day = String(now.getDate()).padStart(2, "0");
//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${minutes}`;
//   };

//   const handlePreview = async () => {
//     if (!quesPaperId) return;
//     const previewUrl = `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_DPP_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperId}`;

//     setPreviewLoading(true);
//     try {
//       const result = await GET.withToken(previewUrl, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (result?.status === 200) {
//         setPreviewData({
//           ques_paper_info: result.ques_paper_info,
//           subjects: result.subjects,
//         });
//         setShowPreviewPopup(true);
//       } else {
//         setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result?.message || "Failed to load preview."}</span></div></div>);
//         setIsMessageBoxVisible(true); setActiveImg(ErrorImg);
//       }
//     } catch (e) {
//       console.error("Preview error:", e);
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   const getOtherPlans = (currentPlanId) =>
//     coursePlans.filter((p) => p.course_plan_id !== currentPlanId);

//   const renderCoursePlanCard = (plan) => {
//     const cardData = coursePlanCardData[plan.course_plan_id] || {
//       dppName: "",
//       description: "",
//       startDate: "",
//       termDate: "",
//       folderName: "",
//       isApplied: false,
//       hasChanges: false,
//     };

//     const isExpanded = expandedCards[plan.course_plan_id] || false;
//     const isEnabled = true;
//     const otherPlans = getOtherPlans(plan.course_plan_id);

//     const canApply =
//       !cardData.isApplied &&
//       cardData.dppName?.trim() &&
//       cardData.description?.trim() &&
//       cardData.startDate &&
//       cardData.folderName;

//     const onApplyClick = () => {
//       if (canApply) {
//         handleApplyCard(plan.course_plan_id);
//         setExpandedCards((prev) => ({ ...prev, [plan.course_plan_id]: false }));
//       }
//     };

//     const handleHeaderClick = (e) => {
//       if (isExpanded && isEnabled) {
//         if (
//           e.target.tagName === "BUTTON" ||
//           e.target.tagName === "INPUT" ||
//           e.target.tagName === "SELECT" ||
//           e.target.closest(".copy-icon-container")
//         )
//           return;
//         setExpandedCards((prev) => ({ ...prev, [plan.course_plan_id]: false }));
//       }
//     };

//     return (
//       <div
//         key={plan.course_plan_id}
//         className="course-plan-card"
//         style={{
//           border: "1px solid var(--DppCardBorder)",
//           borderRadius: "8px",
//           marginBottom: "16px",
//           backgroundColor: isExpanded
//             ? "var(--DppCardBackground)"
//             : "var(--DppCardBackgroundCollapsed)",
//           boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
//           opacity: isEnabled ? 1 : 0.7,
//         }}
//       >
//         {/* Card Header */}
//         <div
//           onClick={handleHeaderClick}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             gap: "16px",
//             padding: "16px 20px",
//             backgroundColor: isExpanded ? "var(--DppCardHeaderExpanded)" : "transparent",
//             borderBottom: isExpanded ? "1px solid var(--DppCardHeaderBorder)" : "none",
//             borderRadius: isExpanded ? "8px 8px 0 0" : "8px",
//             cursor: isExpanded && isEnabled ? "pointer" : "default",
//           }}
//         >
//           {/* Left: Plan Name */}
//           <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", minWidth: "200px" }}>
//             <div style={{ flex: 1 }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                 <h3 style={{ margin: 0, color: "#6A6A6A", fontSize: "15px", fontWeight: "600" }}>
//                   {plan.plan_name}
//                 </h3>
//                 {cardData.isApplied && (
//                   <IoCheckmarkCircle
//                     style={{ color: "var(--DppCheckmarkColor)", fontSize: "18px", marginLeft: "2px" }}
//                   />
//                 )}
//               </div>
//               <p style={{ margin: "2px 0 0 0", color: "#6A6A6A", fontSize: "12px" }}>
//                 {plan.description}
//               </p>
//             </div>

//             {/* Copy Icon */}
//             {isExpanded && isEnabled && otherPlans.length > 0 && (
//               <div
//                 className="copy-icon-container"
//                 style={{ position: "relative", marginTop: "2px" }}
//                 ref={activeCopyDropdown === plan.course_plan_id ? copyDropdownRef : null}
//               >
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setActiveCopyDropdown(
//                       activeCopyDropdown === plan.course_plan_id ? null : plan.course_plan_id
//                     );
//                   }}
//                   style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
//                   title="Copy from another plan"
//                 >
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: "#666" }}>
//                     <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
//                     <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
//                   </svg>
//                 </button>
//                 {activeCopyDropdown === plan.course_plan_id && (
//                   <div style={{ position: "absolute", top: "100%", left: "0", marginTop: "4px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000, minWidth: "200px" }}>
//                     <div style={{ padding: "8px 12px", borderBottom: "1px solid var(--DppDropdownItemBorder)", fontSize: "12px", color: "var(--DppDropdownSubText)", fontWeight: "500" }}>
//                       Copy from...
//                     </div>
//                     {otherPlans.map((p) => (
//                       <div
//                         key={p.course_plan_id}
//                         onClick={(e) => { e.stopPropagation(); handleCopyFromPlan(plan.course_plan_id, p.course_plan_id); }}
//                         style={{ padding: "10px 12px", cursor: "pointer", fontSize: "13px", borderBottom: "1px solid var(--DppDropdownSearchBorder)" }}
//                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
//                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownBackground)"}
//                       >
//                         {p.plan_name}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Collapsed summary */}
//           {!isExpanded && (
//             <>
//               <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
//                 <span style={{ color: "var(--DppLabelText)", fontSize: "14px" }}>DPP Name</span>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px" }}>▾</span>
//                 <span style={{ color: "#6A6A6A", fontSize: "14px", marginLeft: "4px" }}>
//                   {cardData.dppName || "NA"}
//                 </span>
//               </div>
//               <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
//                 <span style={{ color: "var(--DppLabelText)", fontSize: "14px" }}>Folder</span>
//                 <span style={{ color: "var(--DppLabelText)", fontSize: "14px" }}>▾</span>
//                 <span style={{ color: "var(--DppValueText)", fontSize: "14px", marginLeft: "4px" }}>
//                   {cardData.folderName || "NA"}
//                 </span>
//               </div>
//               <button
//                 onClick={(e) => { e.stopPropagation(); toggleCardExpanded(plan.course_plan_id); }}
//                 disabled={!isEnabled}
//                 style={{ background: "none", border: "none", cursor: isEnabled ? "pointer" : "not-allowed", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
//                 title={isEnabled ? "Expand" : "Select a question paper to enable"}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={isEnabled ? "#333" : "#999"} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//                   <polyline points="6 9 12 15 18 9"></polyline>
//                 </svg>
//               </button>
//             </>
//           )}

//           {isExpanded && (
//             <button
//               onClick={(e) => { e.stopPropagation(); toggleCardExpanded(plan.course_plan_id); }}
//               style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
//               title="Collapse"
//             >
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
//                 <polyline points="18 15 12 9 6 15"></polyline>
//               </svg>
//             </button>
//           )}
//         </div>

//         {/* Expanded Body */}
//         {isExpanded && isEnabled && (
//           <div style={{ padding: "20px", backgroundColor: "var(--DppDropdownBackground)" }}>
//             {/* Row 1: DPP Name, Description, Start Date */}
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px" }}>
//               <div>
//                 <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   DPP Name <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={cardData.dppName}
//                   onChange={(e) => updateCardData(plan.course_plan_id, "dppName", e.target.value)}
//                   placeholder="Enter DPP name"
//                   style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", boxSizing: "border-box", color: "#6A6A6A" }}
//                 />
//               </div>
//               <div>
//                 <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Description <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={cardData.description}
//                   onChange={(e) => updateCardData(plan.course_plan_id, "description", e.target.value)}
//                   placeholder="Enter Description"
//                   style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", boxSizing: "border-box", color: "#6A6A6A" }}
//                 />
//               </div>
//               <div>
//                 <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Start Date <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="datetime-local"
//                   min={getCurrentDateTime()}
//                   value={cardData.startDate || ""}
//                   onChange={(e) => updateCardData(plan.course_plan_id, "startDate", e.target.value)}
//                   readOnly={!!(cardData.startDate && new Date(cardData.startDate) < new Date())}
//                   disabled={!!(cardData.startDate && new Date(cardData.startDate) < new Date())}
//                   style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", color: "var(--DppInputText)", boxSizing: "border-box", cursor: cardData.startDate && new Date(cardData.startDate) < new Date() ? "not-allowed" : "pointer", opacity: cardData.startDate && new Date(cardData.startDate) < new Date() ? 0.6 : 1 }}
//                 />
//               </div>
//             </div>

//             {/* Row 2: Term Date + Folder Name */}
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px", marginTop: "16px" }}>
//               <div style={{ gridColumn: "1 / 2" }}>
//                 <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Term Date (Optional)
//                 </label>
//                 <input
//                   type="datetime-local"
//                   min={cardData.startDate || getCurrentDateTime()}
//                   value={cardData.termDate || ""}
//                   onChange={(e) => updateCardData(plan.course_plan_id, "termDate", e.target.value)}
//                   style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", color: "#6A6A6A", boxSizing: "border-box" }}
//                 />
//               </div>
//               <div style={{ gridColumn: "2 / 4" }}>
//                 <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
//                   Folder Name <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <div
//                   ref={activeFolderPicker === plan.course_plan_id ? folderPickerRef : null}
//                   style={{ position: "relative" }}
//                 >
//                   <input
//                     type="text"
//                     value={
//                       folderSearchText[plan.course_plan_id] !== undefined
//                         ? folderSearchText[plan.course_plan_id]
//                         : (coursePlanCardData[plan.course_plan_id]?.folderName || "")
//                     }
//                     onChange={(e) => {
//                       const searchVal = e.target.value;
//                       setFolderSearchText((prev) => ({ ...prev, [plan.course_plan_id]: searchVal }));
//                       if (searchVal.trim()) {
//                         setExpandedLevel1(null);
//                         setExpandedLevel2(null);
//                         setExpandedLevel3(null);
//                       }
//                       if (!activeFolderPicker) setActiveFolderPicker(plan.course_plan_id);
//                     }}
//                     onFocus={() => {
//                       if (activeFolderPicker !== plan.course_plan_id) {
//                         setActiveFolderPicker(plan.course_plan_id);
//                         setFolderSearchText((prev) => ({ ...prev, [plan.course_plan_id]: "" }));
//                       }
//                     }}
//                     placeholder="Select or search folder..."
//                     style={{ width: "100%", padding: "10px 12px", paddingRight: "35px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", boxSizing: "border-box", backgroundColor: "var(--DppDropdownBackground)", color: "#6A6A6A" }}
//                   />
//                   <span
//                     onClick={() => {
//                       if (activeFolderPicker === plan.course_plan_id) {
//                         setActiveFolderPicker(null);
//                         setFolderSearchText((prev) => { const s = { ...prev }; delete s[plan.course_plan_id]; return s; });
//                         setExpandedLevel1(null); setExpandedLevel2(null); setExpandedLevel3(null);
//                       } else {
//                         setActiveFolderPicker(plan.course_plan_id);
//                         setFolderSearchText((prev) => ({ ...prev, [plan.course_plan_id]: "" }));
//                       }
//                     }}
//                     style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", color: "#666", cursor: "pointer" }}
//                   >
//                     ▼
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Folder Picker Dropdowns */}
//             {activeFolderPicker === plan.course_plan_id && folderLevelData[plan.course_plan_id] && (
//               <div ref={dropdownRef} style={{ position: "relative", zIndex: 99999, marginTop: "4px" }}>
//                 {folderSearchText[plan.course_plan_id]?.trim() ? (
//                   <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 10px)", width: "calc(66.66% - 20px)", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 99999, maxHeight: "250px", overflowY: "auto" }}>
//                     {(() => {
//                       const searchTerm = folderSearchText[plan.course_plan_id].toLowerCase();
//                       const results = [];
//                       folderLevelData[plan.course_plan_id].forEach((level1) => {
//                         level1.level2?.forEach((level2) => {
//                           if (level2.name.toLowerCase().includes(searchTerm))
//                             results.push({ type: "level2", level1, level2, level3: null, displayPath: `${level1.name} > ${level2.name}` });
//                           level2.level3?.forEach((level3) => {
//                             if (level3.name.toLowerCase().includes(searchTerm))
//                               results.push({ type: "level3", level1, level2, level3, displayPath: `${level1.name} > ${level2.name} > ${level3.name}` });
//                           });
//                         });
//                       });
//                       if (results.length === 0)
//                         return <div style={{ padding: "12px", color: "var(--DppLabelText)", textAlign: "center" }}>No results found</div>;
//                       return results.map((result, idx) => (
//                         <div
//                           key={idx}
//                           onClick={() => {
//                             const planId = plan.course_plan_id;
//                             setCoursePlanCardData((prev) => ({ ...prev, [planId]: { ...prev[planId], folderName: result.displayPath, folderPath: result.displayPath, selectedLevel1Id: result.level1.dpp_level1_id, selectedLevel2Id: result.level2.dpp_level2_id, selectedLevel3Id: result.level3?.dpp_level3_id || null, isApplied: false, hasChanges: true } }));
//                             setActiveFolderPicker(null);
//                             setFolderSearchText((prev) => { const s = { ...prev }; delete s[planId]; return s; });
//                             setExpandedLevel1(null); setExpandedLevel2(null); setExpandedLevel3(null);
//                           }}
//                           style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder)", color: "var(--DppValueText)", backgroundColor: "var(--DppDropdownBackground)" }}
//                           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
//                           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownBackground)"}
//                         >
//                           {result.displayPath}
//                         </div>
//                       ));
//                     })()}
//                   </div>
//                 ) : (
//                   <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 10px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 99999 }}>
//                     {folderLevelData[plan.course_plan_id].map((level1) => (
//                       <div
//                         key={level1.dpp_level1_id}
//                         onMouseEnter={() => { setExpandedLevel1(level1.dpp_level1_id); setExpandedLevel2(null); setExpandedLevel3(null); }}
//                         style={{ padding: "10px 12px", backgroundColor: expandedLevel1 === level1.dpp_level1_id ? "var(--DppDropdownHoverBackground)" : "var(--DppDropdownBackground)", color: "var(--DppValueText)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: "500", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}
//                       >
//                         <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level1.name}</span>
//                         {level1.level2?.length > 0 && <span style={{ fontSize: "10px", marginLeft: "4px", color: "var(--DppLabelText)" }}>▶</span>}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Level 2 */}
//                 {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel1 && (() => {
//                   const level1Data = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
//                   if (!level1Data?.level2?.length) return null;
//                   return (
//                     <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 232px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 100000 }}>
//                       {level1Data.level2.map((level2) => (
//                         <div
//                           key={level2.dpp_level2_id}
//                           onMouseEnter={() => { setExpandedLevel2(level2.dpp_level2_id); setExpandedLevel3(null); }}
//                           onClick={() => {
//                             const level1 = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
//                             const folderPath = `${level1.name} > ${level2.name}`;
//                             const planId = plan.course_plan_id;
//                             setCoursePlanCardData((prev) => ({ ...prev, [planId]: { ...prev[planId], folderName: folderPath, folderPath, selectedLevel1Id: level1.dpp_level1_id, selectedLevel2Id: level2.dpp_level2_id, selectedLevel3Id: null, isApplied: false, hasChanges: true } }));
//                             setActiveFolderPicker(null);
//                             setFolderSearchText((prev) => { const s = { ...prev }; delete s[planId]; return s; });
//                             setExpandedLevel1(null); setExpandedLevel2(null); setExpandedLevel3(null);
//                           }}
//                           style={{ padding: "10px 12px", backgroundColor: expandedLevel2 === level2.dpp_level2_id ? "var(--DppDropdownHoverBackground)" : "var(--DppDropdownBackground)", color: "var(--DppValueText)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}
//                         >
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level2.name}</span>
//                           {level2.level3?.length > 0 && <span style={{ fontSize: "10px", color: "var(--DppLabelText)", marginLeft: "4px" }}>▶</span>}
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })()}

//                 {/* Level 3 */}
//                 {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel2 && (() => {
//                   const level1Data = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
//                   const level2Data = level1Data?.level2?.find((l) => l.dpp_level2_id === expandedLevel2);
//                   if (!level2Data?.level3?.length) return null;
//                   return (
//                     <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 454px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 100001 }}>
//                       {level2Data.level3.map((level3) => (
//                         <div
//                           key={level3.dpp_level3_id}
//                           onMouseEnter={() => setExpandedLevel3(level3.dpp_level3_id)}
//                           onClick={() => {
//                             const level1 = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
//                             const level2 = level1?.level2?.find((l) => l.dpp_level2_id === expandedLevel2);
//                             const folderPath = `${level1.name} > ${level2.name} > ${level3.name}`;
//                             const planId = plan.course_plan_id;
//                             setCoursePlanCardData((prev) => ({ ...prev, [planId]: { ...prev[planId], folderName: folderPath, folderPath, selectedLevel1Id: level1.dpp_level1_id, selectedLevel2Id: level2.dpp_level2_id, selectedLevel3Id: level3.dpp_level3_id, isApplied: false, hasChanges: true } }));
//                             setActiveFolderPicker(null);
//                             setFolderSearchText((prev) => { const s = { ...prev }; delete s[planId]; return s; });
//                             setExpandedLevel1(null); setExpandedLevel2(null); setExpandedLevel3(null);
//                           }}
//                           style={{ padding: "10px 12px", backgroundColor: expandedLevel3 === level3.dpp_level3_id ? "var(--DppDropdownHoverBackground)" : "var(--DppDropdownBackground)", color: "var(--DppValueText)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}
//                         >
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level3.name}</span>
//                           {level3.dpp_sets?.length > 0 && <span style={{ fontSize: "10px", color: "var(--DppLabelText)", marginLeft: "4px" }}>▶</span>}
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })()}

//                 {/* Level 4 (dpp_sets) */}
//                 {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel3 && (() => {
//                   const level1Data = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
//                   const level2Data = level1Data?.level2?.find((l) => l.dpp_level2_id === expandedLevel2);
//                   const level3Data = level2Data?.level3?.find((l) => l.dpp_level3_id === expandedLevel3);
//                   if (!level3Data?.dpp_sets?.length) return null;
//                   return (
//                     <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 676px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 100002 }}>
//                       {level3Data.dpp_sets.map((dppSet) => (
//                         <div key={dppSet.dpp_schedule_id} style={{ padding: "10px 12px", backgroundColor: "var(--DppDropdownLevel4Background)", color: "var(--DppValueText)", cursor: "default", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}>
//                           <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dppSet.dpp_set_name}</span>
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })()}
//               </div>
//             )}

//             {/* Card Footer */}
//             <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "20px", paddingTop: "16px", borderTop: "1px solid var(--DppSectionBorder)" }}>
//               <button
//                 onClick={() => handleResetCard(plan.course_plan_id)}
//                 style={{ backgroundColor: "var(--DppButtonResetBackground)", color: "var(--DppButtonResetText)", border: "1px solid var(--DppButtonResetBorder)", borderRadius: "4px", padding: "10px 32px", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
//               >
//                 RESET
//               </button>
//               <button
//                 onClick={onApplyClick}
//                 disabled={!canApply}
//                 style={{ backgroundColor: canApply ? "var(--DppButtonApplyBackground)" : "var(--DppButtonApplyBackgroundDisabled)", color: "var(--DppButtonApplyText)", border: "none", borderRadius: "4px", padding: "10px 32px", fontSize: "14px", fontWeight: "500", cursor: canApply ? "pointer" : "not-allowed" }}
//               >
//                 APPLY
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">
//         {/* Page Header */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//           <div style={{ fontSize: "30px", color: "var(--DppPlanNameText)", fontWeight: "400" }}>
//             DPP Schedule
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={() => navigate(-1)}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={handleSave}
//               >
//                 SAVE
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040", opacity: previewLoading ? 0.6 : 1, cursor: previewLoading ? "wait" : "pointer" }}
//                 onClick={!previewLoading ? handlePreview : undefined}
//                 disabled={previewLoading}
//               >
//                 {previewLoading ? "LOADING..." : "PREVIEW"}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* QUESTION PAPER DETAIL — read-only */}
//         <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
//         <div className="Body-1-C424342">
//           {/* Row 1: Course, Subject, Chapter */}
//           <div className="row-cs">
//             <div className="col-cs">
//               <InputComponent
//                 label="Select Course"
//                 style={{ width: "97%" }}
//                 value={selectedCourseName}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               <InputComponent
//                 label="Select Subject"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperSubjects}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* Wrap in title div so hovering shows the full chapter list */}
//               <div title={chapterListFull || undefined}>
//                 <InputComponent
//                   label="Select Chapter (Optional)"
//                   style={{ width: "97%" }}
//                   value={chapterListDisplay}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Row 2: Topic, Question Paper Name, Description */}
//           <div className="row-cs">
//             <div className="col-cs">
//               {/* Topic — truncated display, full value on hover */}
//               <div title={topicListFull || undefined}>
//                 <InputComponent
//                   label="Select Topic (Optional)"
//                   style={{ width: "97%" }}
//                   value={topicListDisplay}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>
//             </div>
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Name"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperName}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Description"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperDescription}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>

//           {/* Row 3: Created By, Subjects, empty */}
//           <div className="row-cs">
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Created By"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperCreatedBy}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               <InputComponent
//                 label="Question Paper Subjects"
//                 style={{ width: "97%" }}
//                 value={selectedQuestionPaperSubjects}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">{/* empty */}</div>
//           </div>

//           {/* Instructions — editable */}
//           <div style={{ marginRight: "15px", marginBottom: "20px" }}>
//             <TextEditor
//               templates={testTemplates}
//               value={instructionsHtml}
//               setValue={setInstructionsHtml}
//             />
//           </div>
//         </div>

//         {/* COURSE PLAN CARDS */}
//         {coursePlans.length > 0 && (
//           <div style={{ marginTop: "30px" }}>
//             <div style={{ fontSize: "15px", fontWeight: "600", color: "#6A6A6A", fontFamily: "'ABeeZee', sans-serif", lineHeight: "14px", marginBottom: "16px" }}>
//               COURSE PLAN DETAILS
//             </div>
//             <div style={{ width: "98%" }}>
//               {coursePlans.map((plan) => renderCoursePlanCard(plan))}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ── Preview Popup ── */}
//       {showPreviewPopup && previewData && (
//         <div
//           style={{
//             position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99999,
//             display: "flex", alignItems: "center", justifyContent: "center",
//           }}
//           onClick={() => setShowPreviewPopup(false)}
//         >
//           <button
//             onClick={(e) => { e.stopPropagation(); setShowPreviewPopup(false); }}
//             style={{
//               position: "absolute", top: "20px", right: "20px",
//               background: "white", border: "1px solid #ccc", borderRadius: "50%",
//               width: "36px", height: "36px", fontSize: "20px", cursor: "pointer",
//               display: "flex", alignItems: "center", justifyContent: "center",
//               color: "#666", fontWeight: "bold", zIndex: 100000,
//             }}
//           >
//             ×
//           </button>

//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               width: "60vw", height: "80vh", backgroundColor: "#fff",
//               borderRadius: "8px", display: "flex", flexDirection: "column",
//               overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//             }}
//           >
//             <div style={{
//               position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 2,
//               padding: "16px 20px", borderBottom: "1px solid #ccc",
//             }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <h3 style={{ margin: 0, color: "rgb(106, 106, 106)" }}>
//                   Preview Question Paper
//                   <span
//                     style={{ marginLeft: "10px", cursor: "pointer", fontSize: "12px", textDecoration: "underline" }}
//                     onClick={() => setShowOptions((prev) => !prev)}
//                   >
//                     {showOptions ? "Hide Options" : "Show Options"}
//                   </span>
//                 </h3>
//               </div>
//               <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginTop: "10px", fontSize: "14px" }}>
//                 <div style={{ flex: "0 0 48%" }}>
//                   <p style={{ marginBottom: "8px" }}><span>Question Paper:</span> {previewData.ques_paper_info?.ques_paper_name || selectedQuestionPaperName || "N/A"}</p>
//                   <p><span>Course:</span> {selectedCourseName || "N/A"}</p>
//                 </div>
//                 <div style={{ flex: "0 0 48%" }}>
//                   <p style={{ marginBottom: "8px" }}><span>Created By:</span> {selectedQuestionPaperCreatedBy || "N/A"}</p>
//                   <p><span>Subjects:</span> {selectedQuestionPaperSubjects || "N/A"}</p>
//                 </div>
//               </div>
//             </div>

//             <div style={{ overflowY: "auto", padding: "20px", flex: 1 }}>
//               {previewData.subjects?.map((subject, subjIdx) => (
//                 <div key={subject.subject_superset_id || subjIdx} style={{ marginBottom: "24px" }}>
//                   <h4 style={{ color: "#424242", marginBottom: "12px", padding: "8px 12px", textAlign: "left" }}>
//                     {subject.subject_superset_name || `Subject ${subjIdx + 1}`}
//                   </h4>

//                   {subject.sections?.map((section, secIdx) => (
//                     <div key={section.section_name || secIdx} style={{ marginBottom: "16px", paddingLeft: "12px" }}>
//                       <h5 style={{ color: "rgb(106, 106, 106)", marginBottom: "18px", textAlign: "left" }}>
//                         Section {section.section_name}
//                       </h5>

//                       {section.questions?.length > 0 ? (
//                         <ul style={{ listStyle: "none", padding: 0 }}>
//                           {section.questions.map((ques, qIdx) => (
//                             <li key={ques.ques_id || qIdx} style={{ marginBottom: "16px", paddingLeft: "8px" }}>
//                               <div style={{ marginBottom: "4px", fontSize: "14px", color: "#424242" }}>
//                                 {qIdx + 1}.{" "}
//                                 {(() => {
//                                   const raw = ques.ques_text || ques.question_text || "";
//                                   const decoded = he.decode(raw);
//                                   const segments = decoded.split(/(imgsrc=[^\s]+)/g);
//                                   return segments.map((seg, i) => {
//                                     if (seg.startsWith("imgsrc=")) {
//                                       const url = seg.replace("imgsrc=", "");
//                                       return <img key={i} src={url} alt={`Q${qIdx + 1}`} style={{ maxHeight: "100px", width: "auto", margin: "5px", verticalAlign: "middle" }} />;
//                                     }
//                                     return <span key={i}><Latex>{seg}</Latex></span>;
//                                   });
//                                 })()}
//                               </div>

//                               {showOptions && ques.options?.length > 0 && (
//                                 <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingLeft: "20px", marginTop: "5px" }}>
//                                   {[0, 1].map((col) => (
//                                     <ul key={col} style={{ flex: "1 1 45%", paddingLeft: "20px", listStyleType: "disc" }}>
//                                       {ques.options
//                                         .filter((_, idx) => idx % 2 === col)
//                                         .map((option, idx) => {
//                                           const globalIndex = col + idx * 2;
//                                           return (
//                                             <li key={option.option_id || globalIndex} style={{ padding: "4px 0", fontSize: "13px", color: "#555" }}>
//                                               {String.fromCharCode(65 + globalIndex).toLowerCase()}.{" "}
//                                               {(() => {
//                                                 const raw = option.option_text || "";
//                                                 const decoded = he.decode(raw);
//                                                 const segments = decoded.split(/(imgsrc=[^\s]+)/g);
//                                                 return segments.map((seg, i) => {
//                                                   if (seg.startsWith("imgsrc=")) {
//                                                     const url = seg.replace("imgsrc=", "");
//                                                     return <img key={i} src={url} alt="option" style={{ maxHeight: "80px", width: "auto", margin: "3px", verticalAlign: "middle" }} />;
//                                                   }
//                                                   return <span key={i}><Latex>{seg}</Latex></span>;
//                                                 });
//                                               })()}
//                                             </li>
//                                           );
//                                         })}
//                                     </ul>
//                                   ))}
//                                 </div>
//                               )}
//                             </li>
//                           ))}
//                         </ul>
//                       ) : (
//                         <p style={{ color: "#999", fontSize: "13px" }}>No questions in this section.</p>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default DPPSchedulingEdit;


































import React, { useState, useEffect, useRef } from "react";
import "./DppScheduling.css";
import DropDown from "./DropdwonClassic";
import InputComponent from "../TestScheduling/Input-testscheduling";
import TextEditor from "./TextEditor";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SucessImg from "../../../Assets/Images/CommanImages/success.png";
import WarnningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import MultiSelectSearchDropdown from "./MultiDropdownClassic";
import { useLocation, useNavigate } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { POST } from "../../../Api/HttpsMethods";
import { GET } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/Endpoints";
import Colors from "../../../Constants/Colors";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";

// Truncate a comma-separated list to fit within a character budget
const truncateList = (value, maxChars = 60) => {
  if (!value) return "";
  const str = String(value);
  if (str.length <= maxChars) return str;
  const cutPoint = str.lastIndexOf(",", maxChars);
  if (cutPoint <= 0) return str.slice(0, maxChars) + "...";
  return str.slice(0, cutPoint) + ", ...";
};

const DPPSchedulingEdit = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const dashboardData = location.state || {};
  const quesPaperId = dashboardData.ques_paper_id;
  const courseIdFromDashboard = dashboardData.course_id;

  console.log("📊 Dashboard data received:", dashboardData);
  console.log("📋 ques_paper_id:", quesPaperId, "| course_id:", courseIdFromDashboard);

  useEffect(() => {
    if (dataClient) {
      const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  // QUESTION PAPER DETAIL state (read-only display)
  const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
  const [selectedQuestionPaperName, setSelectedQuestionPaperName] = useState("");
  const [selectedQuestionPaperDescription, setSelectedQuestionPaperDescription] = useState("");
  const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] = useState("");
  const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState("");

  const [chapterListDisplay, setChapterListDisplay] = useState("");
  const [chapterListFull, setChapterListFull] = useState("");
  const [topicListDisplay, setTopicListDisplay] = useState("");
  const [topicListFull, setTopicListFull] = useState("");

  const [selectedChapterId, setSelectedChapterId] = useState([]);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [selectedTopicId, setSelectedTopicId] = useState([]);
  const [selectedTopicName, setSelectedTopicName] = useState("");
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [questionPapers, setQuestionPapers] = useState([]);

  const [selectedSubjectSupersetId, setSelectedSubjectSupersetId] = useState("");
  // UI Change 1: need subject name to filter folder picker
  const [selectedSubjectSupersetName, setSelectedSubjectSupersetName] = useState("");
  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);

  // Course Plans
  const [coursePlans, setCoursePlans] = useState([]);
  const [coursePlanCardData, setCoursePlanCardData] = useState({});
  const [expandedCards, setExpandedCards] = useState({});

  // Folder picker — removed expandedLevel3, no longer needed
  const [folderLevelData, setFolderLevelData] = useState({});
  const [activeFolderPicker, setActiveFolderPicker] = useState(null);
  const [expandedLevel1, setExpandedLevel1] = useState(null);
  const [expandedLevel2, setExpandedLevel2] = useState(null);
  const [folderSearchText, setFolderSearchText] = useState({});
  const folderPickerRef = useRef(null);
  const dropdownRef = useRef(null);

  const [hasAppliedCards, setHasAppliedCards] = useState(false);
  const [activeCopyDropdown, setActiveCopyDropdown] = useState(null);

  const [previewData, setPreviewData] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  const copyDropdownRef = useRef(null);

  // Close pickers on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeFolderPicker &&
        folderPickerRef.current &&
        !folderPickerRef.current.contains(event.target) &&
        (!dropdownRef.current || !dropdownRef.current.contains(event.target))
      ) {
        setActiveFolderPicker(null);
        setExpandedLevel1(null);
        setExpandedLevel2(null);
        setFolderSearchText({});
      }
      if (
        activeCopyDropdown &&
        copyDropdownRef.current &&
        !copyDropdownRef.current.contains(event.target)
      ) {
        setActiveCopyDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeFolderPicker, activeCopyDropdown]);

  // Populate QUESTION PAPER DETAIL from dashboard data
  useEffect(() => {
    if (!dashboardData || !quesPaperId) return;

    console.log("📝 Populating QUESTION PAPER DETAIL from dashboard data");

    setSelectedQuestionPaperId(quesPaperId);
    setSelectedQuestionPaperName(dashboardData.ques_paper_name || "");
    setSelectedQuestionPaperDescription(dashboardData.ques_paper_desc || "");
    setSelectedCourseName(dashboardData.course || "");
    // UI Change 1: store subject name for folder picker filtering
    setSelectedSubjectSupersetName(dashboardData.subject_name || "");
    setSelectedQuestionPaperSubjects(dashboardData.subject_name || "");
    setSelectedQuestionPaperCreatedBy(dashboardData.scheduled_by || "");

    const chapterFull = dashboardData.chapter_list || "";
    setChapterListFull(chapterFull);
    setChapterListDisplay(truncateList(chapterFull));

    const topicFull = dashboardData.topic_list || "";
    setTopicListFull(topicFull);
    setTopicListDisplay(truncateList(topicFull));

    const numericCourseId = parseInt(courseIdFromDashboard, 10);
    if (!isNaN(numericCourseId)) {
      setSelectedCourseId(numericCourseId);
    } else {
      console.error("❌ course_id is not a valid number:", courseIdFromDashboard);
    }
  }, [dashboardData, quesPaperId]);

  // Fetch existing DPP schedules
  useEffect(() => {
    if (!quesPaperId) {
      console.error("❌ No Question Paper ID provided");
      return;
    }
    const numericQuesPaperId = parseInt(quesPaperId);
    if (isNaN(numericQuesPaperId)) {
      console.error("❌ Invalid ques_paper_id:", quesPaperId);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Invalid Question Paper ID. Please return to dashboard and try again.</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }
    console.log("🔄 Fetching DPP schedules for ques_paper_id:", numericQuesPaperId);
    fetchDppSchedulesByQuesPaperId(numericQuesPaperId);
  }, [quesPaperId]);

  const fetchDppSchedulesByQuesPaperId = async (quesPaperId) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_SCHEDULE_BY_QUES_PAPER_ID}?ques_paper_id=${quesPaperId}`;
      console.log("🌐 Full API Call URL:", API_ENDPOINT);

      const result = await GET.withToken(API_ENDPOINT);
      console.log("📥 API Response received:", result);

      if (result?.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
        const schedules = result.data;
        const firstSchedule = schedules[0];

        if (firstSchedule.dpp_desc && !selectedQuestionPaperDescription) {
          setSelectedQuestionPaperDescription(firstSchedule.dpp_desc);
        }

        setInstructionsHtml(firstSchedule.instructions_html || "");

        const numericCourseId = parseInt(courseIdFromDashboard, 10);
        if (!isNaN(numericCourseId)) {
          console.log("📚 Using course_id from dashboard:", numericCourseId);
          setSelectedCourseId(numericCourseId);
          await fetchCoursePlansForEdit(numericCourseId, schedules);
        } else {
          console.warn("⚠️ Falling back to course name lookup:", dashboardData.course);
          if (dashboardData.course) {
            await fetchCourseIdFromCourseName(dashboardData.course, schedules);
          }
        }
      } else {
        console.log("ℹ️ No existing schedules — loading empty cards");
        const numericCourseId = parseInt(courseIdFromDashboard, 10);
        if (!isNaN(numericCourseId)) {
          await fetchCoursePlansForEdit(numericCourseId, []);
        }
      }
    } catch (error) {
      console.error("❌ Error fetching DPP schedules:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Error loading DPP schedule data. Please check console for details.</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  const fetchCourseIdFromCourseName = async (courseName, schedules) => {
    try {
      const result = await GET.withToken(EndPoints.PRISM_GET_COURSES);
      if (result?.status === 200 && Array.isArray(result.data)) {
        const course = result.data.find((c) => c.course_name === courseName);
        if (course) {
          console.log("✅ Resolved course_id:", course.course_id, "for:", courseName);
          setSelectedCourseId(course.course_id);
          await fetchCoursePlansForEdit(course.course_id, schedules);
        } else {
          console.error("❌ Course not found:", courseName);
        }
      }
    } catch (error) {
      console.error("❌ Error fetching courses:", error);
    }
  };

  const fetchCoursePlansForEdit = async (courseId, existingSchedules) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_COURSE_PLAN}?course_id=${courseId}`;
      console.log("📚 Fetching course plans from:", API_ENDPOINT);

      const result = await GET.withToken(API_ENDPOINT);
      console.log("📚 Course Plans API Response:", result);

      if (result?.status === 200 && Array.isArray(result.data)) {
        setCoursePlans(result.data);

        const folderLevelsPromises = result.data.map((plan) =>
          fetchFolderLevelsData(plan.course_plan_id)
        );
        const allFolderLevels = await Promise.all(folderLevelsPromises);

        const folderLevelsMap = {};
        result.data.forEach((plan, index) => {
          folderLevelsMap[plan.course_plan_id] = allFolderLevels[index];
        });

        const initialData = {};
        const initialExpanded = {};

        result.data.forEach((plan) => {
          const matchingSchedule = existingSchedules.find(
            (s) => s.course_plan_id === plan.course_plan_id
          );

          if (matchingSchedule) {
            let folderPath = "";
            const planFolderLevels = folderLevelsMap[plan.course_plan_id];

            if (planFolderLevels && matchingSchedule.dpp_level1_id) {
              const level1 = planFolderLevels.find(
                (l) => l.dpp_level1_id === matchingSchedule.dpp_level1_id
              );
              if (level1) {
                folderPath = level1.name;
                if (matchingSchedule.dpp_level2_id && level1.level2) {
                  const level2 = level1.level2.find(
                    (l) => l.dpp_level2_id === matchingSchedule.dpp_level2_id
                  );
                  if (level2) {
                    folderPath += ` > ${level2.name}`;
                    if (matchingSchedule.dpp_level3_id && level2.level3) {
                      const level3 = level2.level3.find(
                        (l) => l.dpp_level3_id === matchingSchedule.dpp_level3_id
                      );
                      if (level3) folderPath += ` > ${level3.name}`;
                    }
                  }
                }
              }
            }

            initialData[plan.course_plan_id] = {
              dppScheduleId: matchingSchedule.dpp_schedule_id,
              dppName: matchingSchedule.dpp_name || "",
              description: matchingSchedule.dpp_desc || "",
              startDate: matchingSchedule.dpp_window_start
                ? matchingSchedule.dpp_window_start.replace(" ", "T").slice(0, 16)
                : "",
              termDate: matchingSchedule.dpp_term_date
                ? matchingSchedule.dpp_term_date.replace(" ", "T").slice(0, 16)
                : "",
              folderName: folderPath,
              folderPath: folderPath,
              selectedLevel1Id: matchingSchedule.dpp_level1_id,
              selectedLevel2Id: matchingSchedule.dpp_level2_id,
              selectedLevel3Id: matchingSchedule.dpp_level3_id,
              isApplied: true,
              originalData: { ...matchingSchedule, folderPath },
              hasChanges: false,
            };
            initialExpanded[plan.course_plan_id] = true;
          } else {
            initialData[plan.course_plan_id] = {
              dppName: "",
              description: "",
              startDate: "",
              termDate: "",
              folderName: "",
              folderPath: "",
              selectedLevel1Id: null,
              selectedLevel2Id: null,
              selectedLevel3Id: null,
              isApplied: false,
              originalData: null,
              hasChanges: false,
            };
            initialExpanded[plan.course_plan_id] = false;
          }
        });

        setCoursePlanCardData(initialData);
        setExpandedCards(initialExpanded);

        Object.entries(folderLevelsMap).forEach(([planId, levels]) => {
          if (levels) {
            setFolderLevelData((prev) => ({ ...prev, [planId]: levels }));
          }
        });
      } else {
        console.warn("⚠️ Invalid course plans response:", result);
      }
    } catch (error) {
      console.error("❌ Error fetching course plans:", error);
    }
  };

  const fetchFolderLevelsData = async (coursePlanId) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_FOLDER_STRUCTURE}?course_plan_id=${coursePlanId}`;
      const result = await GET.withToken(API_ENDPOINT);
      if (result?.status === 200 && Array.isArray(result.data)) return result.data;
      return null;
    } catch (error) {
      console.error(`❌ Error fetching folder levels for plan ${coursePlanId}:`, error);
      return null;
    }
  };

  const fetchFolderLevels = async (coursePlanId) => {
    try {
      const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_FOLDER_STRUCTURE}?course_plan_id=${coursePlanId}`;
      const result = await GET.withToken(API_ENDPOINT);
      if (result?.status === 200 && Array.isArray(result.data)) {
        setFolderLevelData((prev) => ({ ...prev, [coursePlanId]: result.data }));
      }
    } catch (error) {
      console.error(`❌ Error fetching folder levels for plan ${coursePlanId}:`, error);
    }
  };

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    const fetchTestTemplates = async () => {
      try {
        const API_ENDPOINT = `${EndPoints.PRISM_GET_DPP_INSTRUCTIONS_TEMPLATE_LIST}?username=${userName}&branch_id=${clientBranchId}`;
        const data = await GET.withToken(API_ENDPOINT);
        if (data?.status === 200 && Array.isArray(data.data)) setTestTemplates(data.data);
        else if (Array.isArray(data)) setTestTemplates(data);
      } catch (error) {
        console.error("Error fetching test templates:", error);
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await GET.withToken(EndPoints.PRISM_GET_COURSES);
        if (data) setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  const updateCardData = (planId, field, value) => {
    setCoursePlanCardData((prev) => ({
      ...prev,
      [planId]: { ...prev[planId], [field]: value, isApplied: false, hasChanges: true },
    }));
  };

  const handleApplyCard = (planId) => {
    const cardData = coursePlanCardData[planId];
    if (
      !cardData.dppName?.trim() ||
      !cardData.description?.trim() ||
      !cardData.startDate ||
      !cardData.folderName
    ) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>
              Please fill all required fields: DPP Name, Description, Start Date, and Folder Name.
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const currentSnapshot = {
      dpp_name: cardData.dppName,
      dpp_desc: cardData.description,
      dpp_window_start: cardData.startDate,
      dpp_term_date: cardData.termDate,
      folderPath: cardData.folderName,
      dpp_level1_id: cardData.selectedLevel1Id,
      dpp_level2_id: cardData.selectedLevel2Id,
      dpp_level3_id: cardData.selectedLevel3Id,
      dpp_schedule_id: cardData.dppScheduleId,
    };

    setCoursePlanCardData((prev) => ({
      ...prev,
      [planId]: { ...prev[planId], isApplied: true, originalData: currentSnapshot, hasChanges: true },
    }));
    setHasAppliedCards(true);
  };

  const handleResetCard = (planId) => {
    const original = coursePlanCardData[planId]?.originalData;
    if (original) {
      const folderPath = original.folderPath || "";
      setCoursePlanCardData((prev) => ({
        ...prev,
        [planId]: {
          ...prev[planId],
          dppName: original.dpp_name || "",
          description: original.dpp_desc || "",
          startDate: original.dpp_window_start?.replace(" ", "T").slice(0, 16) || "",
          termDate: original.dpp_term_date?.replace(" ", "T").slice(0, 16) || "",
          folderName: folderPath,
          folderPath: folderPath,
          selectedLevel1Id: original.dpp_level1_id,
          selectedLevel2Id: original.dpp_level2_id,
          selectedLevel3Id: original.dpp_level3_id,
          isApplied: true,
          hasChanges: false,
        },
      }));
    }
  };

  const handleCopyFromPlan = (targetPlanId, sourcePlanId) => {
    if (!sourcePlanId || sourcePlanId === targetPlanId) return;
    const sourceData = coursePlanCardData[sourcePlanId];
    if (sourceData) {
      setCoursePlanCardData((prev) => ({
        ...prev,
        [targetPlanId]: {
          ...prev[targetPlanId],
          dppName: sourceData.dppName,
          description: sourceData.description,
          startDate: sourceData.startDate,
          termDate: sourceData.termDate,
          folderName: sourceData.folderName,
          folderPath: sourceData.folderPath,
          selectedLevel1Id: sourceData.selectedLevel1Id,
          selectedLevel2Id: sourceData.selectedLevel2Id,
          selectedLevel3Id: sourceData.selectedLevel3Id,
          isApplied: false,
          hasChanges: true,
        },
      }));
      setActiveCopyDropdown(null);
    }
  };

  const toggleCardExpanded = (planId) => {
    setExpandedCards((prev) => ({ ...prev, [planId]: !prev[planId] }));
  };

  const handleSave = async () => {
    const cardsToSave = Object.entries(coursePlanCardData)
      .filter(([_, data]) => data.isApplied && data.hasChanges)
      .map(([planId, data]) => ({
        ques_paper_id: parseInt(selectedQuestionPaperId),
        dpp_name: data.dppName,
        dpp_desc: data.description,
        dpp_abb: "",
        dpp_window_start: data.startDate ? data.startDate.replace("T", " ") + ":00" : null,
        dpp_window_end: data.startDate ? data.startDate.replace("T", " ") + ":00" : null,
        course_plan_id: parseInt(planId),
        dpp_level1_id: data.selectedLevel1Id,
        dpp_level2_id: data.selectedLevel2Id,
        dpp_level3_id: data.selectedLevel3Id || null,
        subject_superset_id: selectedSubjectIds?.length > 0 ? selectedSubjectIds : null,
        chapter_names: selectedChapterName || null,
        topic_names: selectedTopicName || null,
        dedicated_client_id: clientId ? parseInt(clientId, 10) : null,
        dpp_term_date: data.termDate ? data.termDate.replace("T", " ") + ":00" : null,
        instructions_html: instructionsHtml || null,
        created_by: userName,
        ...(data.dppScheduleId && { dpp_schedule_id: data.dppScheduleId }),
      }));

    if (cardsToSave.length === 0) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>No changes to save.</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const isUpdate = cardsToSave.some((card) => card.dpp_schedule_id);

    try {
      const result = await POST.withToken(
        EndPoints.PRISM_CREATE_DPP_SCHEDULE,
        cardsToSave,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );

      if (result?.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                {isUpdate
                  ? "DPP schedule updated successfully"
                  : "DPP schedule created successfully"}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(SucessImg);
        setTimeout(() => navigate(-1), 1000);
      }
    } catch (error) {
      console.error("Error saving DPP schedule:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Error saving DPP schedule</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handlePreview = async () => {
    if (!quesPaperId) return;
    const previewUrl = `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_DPP_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperId}`;

    setPreviewLoading(true);
    try {
      const result = await GET.withToken(previewUrl, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
      if (result?.status === 200) {
        setPreviewData({
          ques_paper_info: result.ques_paper_info,
          subjects: result.subjects,
        });
        setShowPreviewPopup(true);
      } else {
        setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result?.message || "Failed to load preview."}</span></div></div>);
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    } catch (e) {
      console.error("Preview error:", e);
    } finally {
      setPreviewLoading(false);
    }
  };

  const getOtherPlans = (currentPlanId) =>
    coursePlans.filter((p) => p.course_plan_id !== currentPlanId);

  const renderCoursePlanCard = (plan) => {
    const cardData = coursePlanCardData[plan.course_plan_id] || {
      dppName: "",
      description: "",
      startDate: "",
      termDate: "",
      folderName: "",
      isApplied: false,
      hasChanges: false,
    };

    const isExpanded = expandedCards[plan.course_plan_id] || false;
    const isEnabled = true;
    const otherPlans = getOtherPlans(plan.course_plan_id);

    const canApply =
      !cardData.isApplied &&
      cardData.dppName?.trim() &&
      cardData.description?.trim() &&
      cardData.startDate &&
      cardData.folderName;

    const onApplyClick = () => {
      if (canApply) {
        handleApplyCard(plan.course_plan_id);
        setExpandedCards((prev) => ({ ...prev, [plan.course_plan_id]: false }));
      }
    };

    const handleHeaderClick = (e) => {
      if (isExpanded && isEnabled) {
        if (
          e.target.tagName === "BUTTON" ||
          e.target.tagName === "INPUT" ||
          e.target.tagName === "SELECT" ||
          e.target.closest(".copy-icon-container")
        )
          return;
        setExpandedCards((prev) => ({ ...prev, [plan.course_plan_id]: false }));
      }
    };

    // UI Change 1: filter level2 to only the selected subject
    const getFilteredLevel2 = (level2Array) => {
      if (!selectedSubjectSupersetName || !Array.isArray(level2Array)) return level2Array || [];
      return level2Array.filter(
        (l2) => l2.name.toLowerCase() === selectedSubjectSupersetName.toLowerCase()
      );
    };

    return (
      <div
        key={plan.course_plan_id}
        className="course-plan-card"
        style={{
          border: "1px solid var(--DppCardBorder)",
          borderRadius: "8px",
          marginBottom: "16px",
          backgroundColor: isExpanded ? "var(--DppCardBackground)" : "var(--DppCardBackgroundCollapsed)",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
          opacity: isEnabled ? 1 : 0.7,
        }}
      >
        {/* Card Header */}
        <div
          onClick={handleHeaderClick}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            padding: "16px 20px",
            backgroundColor: isExpanded ? "var(--DppCardHeaderExpanded)" : "transparent",
            borderBottom: isExpanded ? "1px solid var(--DppCardHeaderBorder)" : "none",
            borderRadius: isExpanded ? "8px 8px 0 0" : "8px",
            cursor: isExpanded && isEnabled ? "pointer" : "default",
          }}
        >
          {/* Left: Plan Name */}
          <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", minWidth: "200px" }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <h3 style={{ margin: 0, color: "#6A6A6A", fontSize: "15px", fontWeight: "600" }}>
                  {plan.plan_name}
                </h3>
                {cardData.isApplied && (
                  <IoCheckmarkCircle
                    style={{ color: "var(--DppCheckmarkColor)", fontSize: "18px", marginLeft: "2px" }}
                  />
                )}
              </div>
              <p style={{ margin: "2px 0 0 0", color: "#6A6A6A", fontSize: "12px" }}>
                {plan.description}
              </p>
            </div>

            {/* Copy Icon */}
            {isExpanded && isEnabled && otherPlans.length > 0 && (
              <div
                className="copy-icon-container"
                style={{ position: "relative", marginTop: "2px" }}
                ref={activeCopyDropdown === plan.course_plan_id ? copyDropdownRef : null}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveCopyDropdown(
                      activeCopyDropdown === plan.course_plan_id ? null : plan.course_plan_id
                    );
                  }}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
                  title="Copy from another plan"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: "#666" }}>
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                </button>
                {activeCopyDropdown === plan.course_plan_id && (
                  <div style={{ position: "absolute", top: "100%", left: "0", marginTop: "4px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 1000, minWidth: "200px" }}>
                    <div style={{ padding: "8px 12px", borderBottom: "1px solid var(--DppDropdownItemBorder)", fontSize: "12px", color: "var(--DppDropdownSubText)", fontWeight: "500" }}>
                      Copy from...
                    </div>
                    {otherPlans.map((p) => (
                      <div
                        key={p.course_plan_id}
                        onClick={(e) => { e.stopPropagation(); handleCopyFromPlan(plan.course_plan_id, p.course_plan_id); }}
                        style={{ padding: "10px 12px", cursor: "pointer", fontSize: "13px", borderBottom: "1px solid var(--DppDropdownSearchBorder)" }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownBackground)"}
                      >
                        {p.plan_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Collapsed summary */}
          {!isExpanded && (
            <>
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                <span style={{ color: "var(--DppLabelText)", fontSize: "14px" }}>DPP Name</span>
                <span style={{ color: "#6A6A6A", fontSize: "14px" }}>▾</span>
                <span style={{ color: "#6A6A6A", fontSize: "14px", marginLeft: "4px" }}>
                  {cardData.dppName || "NA"}
                </span>
              </div>
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span style={{ color: "var(--DppLabelText)", fontSize: "14px" }}>Folder</span>
                <span style={{ color: "var(--DppLabelText)", fontSize: "14px" }}>▾</span>
                <span style={{ color: "var(--DppValueText)", fontSize: "14px", marginLeft: "4px" }}>
                  {cardData.folderName || "NA"}
                </span>
              </div>
              <button
                onClick={(e) => { e.stopPropagation(); toggleCardExpanded(plan.course_plan_id); }}
                disabled={!isEnabled}
                style={{ background: "none", border: "none", cursor: isEnabled ? "pointer" : "not-allowed", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
                title={isEnabled ? "Expand" : "Select a question paper to enable"}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={isEnabled ? "#333" : "#999"} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
            </>
          )}

          {isExpanded && (
            <button
              onClick={(e) => { e.stopPropagation(); toggleCardExpanded(plan.course_plan_id); }}
              style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
              title="Collapse"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            </button>
          )}
        </div>

        {/* Expanded Body */}
        {isExpanded && isEnabled && (
          <div style={{ padding: "20px", backgroundColor: "var(--DppDropdownBackground)" }}>
            {/* Row 1: DPP Name, Description, Start Date */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px" }}>
              <div>
                <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  DPP Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  value={cardData.dppName}
                  onChange={(e) => updateCardData(plan.course_plan_id, "dppName", e.target.value)}
                  placeholder="Enter DPP name"
                  style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", boxSizing: "border-box", color: "#6A6A6A" }}
                />
              </div>
              <div>
                <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Description <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  value={cardData.description}
                  onChange={(e) => updateCardData(plan.course_plan_id, "description", e.target.value)}
                  placeholder="Enter Description"
                  style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", boxSizing: "border-box", color: "#6A6A6A" }}
                />
              </div>
              <div>
                <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Start Date <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="datetime-local"
                  min={getCurrentDateTime()}
                  value={cardData.startDate || ""}
                  onChange={(e) => updateCardData(plan.course_plan_id, "startDate", e.target.value)}
                  readOnly={!!(cardData.startDate && new Date(cardData.startDate) < new Date())}
                  disabled={!!(cardData.startDate && new Date(cardData.startDate) < new Date())}
                  style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", color: "var(--DppInputText)", boxSizing: "border-box", cursor: cardData.startDate && new Date(cardData.startDate) < new Date() ? "not-allowed" : "pointer", opacity: cardData.startDate && new Date(cardData.startDate) < new Date() ? 0.6 : 1 }}
                />
              </div>
            </div>

            {/* Row 2: Term Date + Folder Name */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px", marginTop: "16px" }}>
              <div style={{ gridColumn: "1 / 2" }}>
                <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Term Date (Optional)
                </label>
                <input
                  type="datetime-local"
                  min={cardData.startDate || getCurrentDateTime()}
                  value={cardData.termDate || ""}
                  onChange={(e) => updateCardData(plan.course_plan_id, "termDate", e.target.value)}
                  style={{ width: "100%", padding: "10px 12px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", color: "#6A6A6A", boxSizing: "border-box" }}
                />
              </div>
              <div style={{ gridColumn: "2 / 4" }}>
                <label style={{ color: "var(--DppLabelText)", fontSize: "14px", display: "block", marginBottom: "6px" }}>
                  Folder Name <span style={{ color: "red" }}>*</span>
                </label>
                <div
                  ref={activeFolderPicker === plan.course_plan_id ? folderPickerRef : null}
                  style={{ position: "relative" }}
                >
                  <input
                    type="text"
                    value={
                      folderSearchText[plan.course_plan_id] !== undefined
                        ? folderSearchText[plan.course_plan_id]
                        : (coursePlanCardData[plan.course_plan_id]?.folderName || "")
                    }
                    onChange={(e) => {
                      const searchVal = e.target.value;
                      setFolderSearchText((prev) => ({ ...prev, [plan.course_plan_id]: searchVal }));
                      if (searchVal.trim()) {
                        setExpandedLevel1(null);
                        setExpandedLevel2(null);
                      }
                      if (!activeFolderPicker) setActiveFolderPicker(plan.course_plan_id);
                    }}
                    onFocus={() => {
                      if (activeFolderPicker !== plan.course_plan_id) {
                        setActiveFolderPicker(plan.course_plan_id);
                        setFolderSearchText((prev) => ({ ...prev, [plan.course_plan_id]: "" }));
                      }
                    }}
                    placeholder="Select or search folder..."
                    style={{ width: "100%", padding: "10px 12px", paddingRight: "35px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", fontSize: "14px", boxSizing: "border-box", backgroundColor: "var(--DppDropdownBackground)", color: "#6A6A6A" }}
                  />
                  <span
                    onClick={() => {
                      if (activeFolderPicker === plan.course_plan_id) {
                        setActiveFolderPicker(null);
                        setFolderSearchText((prev) => { const s = { ...prev }; delete s[plan.course_plan_id]; return s; });
                        setExpandedLevel1(null);
                        setExpandedLevel2(null);
                      } else {
                        setActiveFolderPicker(plan.course_plan_id);
                        setFolderSearchText((prev) => ({ ...prev, [plan.course_plan_id]: "" }));
                      }
                    }}
                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", color: "#666", cursor: "pointer" }}
                  >
                    ▼
                  </span>
                </div>
              </div>
            </div>

            {/* Folder Picker Dropdowns */}
            {activeFolderPicker === plan.course_plan_id && folderLevelData[plan.course_plan_id] && (
              <div ref={dropdownRef} style={{ position: "relative", zIndex: 99999, marginTop: "4px" }}>

                {/* Search Results */}
                {folderSearchText[plan.course_plan_id]?.trim() ? (
                  <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 10px)", width: "calc(66.66% - 20px)", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: 99999, maxHeight: "250px", overflowY: "auto" }}>
                    {(() => {
                      const searchTerm = folderSearchText[plan.course_plan_id].toLowerCase();
                      const results = [];
                      // UI Change 1 (search): filter to selected subject, UI Change 2: only level3 results
                      folderLevelData[plan.course_plan_id].forEach((level1) => {
                        const filteredLevel2 = getFilteredLevel2(level1.level2);
                        filteredLevel2.forEach((level2) => {
                          level2.level3?.forEach((level3) => {
                            if (level3.name.toLowerCase().includes(searchTerm)) {
                              results.push({
                                level1,
                                level2,
                                level3,
                                displayPath: `${level1.name} > ${level2.name} > ${level3.name}`,
                              });
                            }
                          });
                        });
                      });
                      if (results.length === 0)
                        return <div style={{ padding: "12px", color: "var(--DppLabelText)", textAlign: "center" }}>No results found</div>;
                      return results.map((result, idx) => (
                        <div
                          key={idx}
                          onClick={() => {
                            const planId = plan.course_plan_id;
                            setCoursePlanCardData((prev) => ({
                              ...prev,
                              [planId]: {
                                ...prev[planId],
                                folderName: result.displayPath,
                                folderPath: result.displayPath,
                                selectedLevel1Id: result.level1.dpp_level1_id,
                                selectedLevel2Id: result.level2.dpp_level2_id,
                                selectedLevel3Id: result.level3.dpp_level3_id,
                                isApplied: false,
                                hasChanges: true,
                              },
                            }));
                            setActiveFolderPicker(null);
                            setFolderSearchText((prev) => { const s = { ...prev }; delete s[planId]; return s; });
                            setExpandedLevel1(null);
                            setExpandedLevel2(null);
                          }}
                          style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid var(--DppDropdownItemBorder)", color: "var(--DppValueText)", backgroundColor: "var(--DppDropdownBackground)" }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownBackground)"}
                        >
                          {result.displayPath}
                        </div>
                      ));
                    })()}
                  </div>
                ) : (
                  /* Level 1 — unselectable */
                  <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 10px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 99999 }}>
                    {folderLevelData[plan.course_plan_id].map((level1) => {
                      // UI Change 1: only show ▶ if filtered subject exists under this level1
                      const filteredLevel2 = getFilteredLevel2(level1.level2);
                      return (
                        <div
                          key={level1.dpp_level1_id}
                          onMouseEnter={() => { setExpandedLevel1(level1.dpp_level1_id); setExpandedLevel2(null); }}
                          style={{ padding: "10px 12px", backgroundColor: expandedLevel1 === level1.dpp_level1_id ? "var(--DppDropdownHoverBackground)" : "var(--DppDropdownBackground)", color: "var(--DppValueText)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: "500", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}
                        >
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level1.name}</span>
                          {filteredLevel2.length > 0 && <span style={{ fontSize: "10px", marginLeft: "4px", color: "var(--DppLabelText)" }}>▶</span>}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Level 2 (Subject) — unselectable, filtered to selected subject */}
                {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel1 && (() => {
                  const level1Data = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
                  const filteredLevel2 = getFilteredLevel2(level1Data?.level2);
                  if (!filteredLevel2.length) return null;
                  return (
                    <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 232px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 100000 }}>
                      {filteredLevel2.map((level2) => (
                        <div
                          key={level2.dpp_level2_id}
                          onMouseEnter={() => { setExpandedLevel2(level2.dpp_level2_id); }}
                          // UI Change 2: no onClick — subject level is NOT selectable
                          style={{ padding: "10px 12px", backgroundColor: expandedLevel2 === level2.dpp_level2_id ? "var(--DppDropdownHoverBackground)" : "var(--DppDropdownBackground)", color: "var(--DppValueText)", cursor: "default", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}
                        >
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level2.name}</span>
                          {level2.level3?.length > 0 && <span style={{ fontSize: "10px", color: "var(--DppLabelText)", marginLeft: "4px" }}>▶</span>}
                        </div>
                      ))}
                    </div>
                  );
                })()}

                {/* Level 3 (Chapter) — selectable only */}
                {!folderSearchText[plan.course_plan_id]?.trim() && expandedLevel2 && (() => {
                  const level1Data = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
                  const filteredLevel2 = getFilteredLevel2(level1Data?.level2);
                  const level2Data = filteredLevel2.find((l) => l.dpp_level2_id === expandedLevel2);
                  if (!level2Data?.level3?.length) return null;
                  return (
                    <div style={{ position: "absolute", top: "0", left: "calc(33.33% + 454px)", width: "220px", backgroundColor: "var(--DppDropdownBackground)", border: "1px solid var(--DppDropdownBorder)", borderRadius: "4px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", maxHeight: "200px", overflowY: "auto", zIndex: 100001 }}>
                      {level2Data.level3.map((level3) => (
                        <div
                          key={level3.dpp_level3_id}
                          onClick={() => {
                            // UI Change 2: only level3 (chapter) is selectable
                            const level1 = folderLevelData[plan.course_plan_id].find((l) => l.dpp_level1_id === expandedLevel1);
                            const level2 = getFilteredLevel2(level1?.level2).find((l) => l.dpp_level2_id === expandedLevel2);
                            const folderPath = `${level1.name} > ${level2.name} > ${level3.name}`;
                            const planId = plan.course_plan_id;
                            setCoursePlanCardData((prev) => ({
                              ...prev,
                              [planId]: {
                                ...prev[planId],
                                folderName: folderPath,
                                folderPath,
                                selectedLevel1Id: level1.dpp_level1_id,
                                selectedLevel2Id: level2.dpp_level2_id,
                                selectedLevel3Id: level3.dpp_level3_id,
                                isApplied: false,
                                hasChanges: true,
                              },
                            }));
                            setActiveFolderPicker(null);
                            setFolderSearchText((prev) => { const s = { ...prev }; delete s[planId]; return s; });
                            setExpandedLevel1(null);
                            setExpandedLevel2(null);
                          }}
                          style={{ padding: "10px 12px", backgroundColor: "#fff", color: "var(--DppValueText)", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid var(--DppDropdownItemBorder)" }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--DppDropdownHoverBackground)"}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
                        >
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{level3.name}</span>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            )}

            {/* Card Footer */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "20px", paddingTop: "16px", borderTop: "1px solid var(--DppSectionBorder)" }}>
              <button
                onClick={() => handleResetCard(plan.course_plan_id)}
                style={{ backgroundColor: "var(--DppButtonResetBackground)", color: "var(--DppButtonResetText)", border: "1px solid var(--DppButtonResetBorder)", borderRadius: "4px", padding: "10px 32px", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
              >
                RESET
              </button>
              <button
                onClick={onApplyClick}
                disabled={!canApply}
                style={{ backgroundColor: canApply ? "var(--DppButtonApplyBackground)" : "var(--DppButtonApplyBackgroundDisabled)", color: "var(--DppButtonApplyText)", border: "none", borderRadius: "4px", padding: "10px 32px", fontSize: "14px", fontWeight: "500", cursor: canApply ? "pointer" : "not-allowed" }}
              >
                APPLY
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="Leftmargin-Main-DIV">
        {/* Page Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
          <div style={{ fontSize: "30px", color: "var(--DppPlanNameText)", fontWeight: "400" }}>
            DPP Schedule
          </div>
          <div>
            <div className="row-cs-uni">
              <button
                className="create-test-section-btn"
                style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }}
                onClick={() => navigate(-1)}
              >
                CANCEL
              </button>
              <button
                className="create-test-section-btn"
                style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }}
                onClick={handleSave}
              >
                SAVE
              </button>
              <button
                className="create-test-section-btn"
                style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040", opacity: previewLoading ? 0.6 : 1, cursor: previewLoading ? "wait" : "pointer" }}
                onClick={!previewLoading ? handlePreview : undefined}
                disabled={previewLoading}
              >
                {previewLoading ? "LOADING..." : "PREVIEW"}
              </button>
            </div>
          </div>
        </div>

        {/* QUESTION PAPER DETAIL — read-only */}
        <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
        <div className="Body-1-C424342">
          {/* Row 1: Course, Subject, Chapter */}
          <div className="row-cs">
            <div className="col-cs">
              <InputComponent
                label="Select Course"
                style={{ width: "97%" }}
                value={selectedCourseName}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Select Subject"
                style={{ width: "97%" }}
                value={selectedQuestionPaperSubjects}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <div title={chapterListFull || undefined}>
                <InputComponent
                  label="Select Chapter (Optional)"
                  style={{ width: "97%" }}
                  value={chapterListDisplay}
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>
          </div>

          {/* Row 2: Topic, Question Paper Name, Description */}
          <div className="row-cs">
            <div className="col-cs">
              <div title={topicListFull || undefined}>
                <InputComponent
                  label="Select Topic (Optional)"
                  style={{ width: "97%" }}
                  value={topicListDisplay}
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Name"
                style={{ width: "97%" }}
                value={selectedQuestionPaperName}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Description"
                style={{ width: "97%" }}
                value={selectedQuestionPaperDescription}
                isRequired={false}
                disable={true}
              />
            </div>
          </div>

          {/* Row 3: Created By, Subjects, empty */}
          <div className="row-cs">
            <div className="col-cs">
              <InputComponent
                label="Question Paper Created By"
                style={{ width: "97%" }}
                value={selectedQuestionPaperCreatedBy}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Subjects"
                style={{ width: "97%" }}
                value={selectedQuestionPaperSubjects}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">{/* empty */}</div>
          </div>

          {/* Instructions — editable */}
          <div style={{ marginRight: "15px", marginBottom: "20px" }}>
            <TextEditor
              templates={testTemplates}
              value={instructionsHtml}
              setValue={setInstructionsHtml}
            />
          </div>
        </div>

        {/* COURSE PLAN CARDS */}
        {coursePlans.length > 0 && (
          <div style={{ marginTop: "30px" }}>
            <div style={{ fontSize: "15px", fontWeight: "600", color: "#6A6A6A", fontFamily: "'ABeeZee', sans-serif", lineHeight: "14px", marginBottom: "16px" }}>
              COURSE PLAN DETAILS
            </div>
            <div style={{ width: "98%" }}>
              {coursePlans.map((plan) => renderCoursePlanCard(plan))}
            </div>
          </div>
        )}
      </div>

      {/* Preview Popup */}
      {showPreviewPopup && previewData && (
        <div
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99999, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setShowPreviewPopup(false)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setShowPreviewPopup(false); }}
            style={{ position: "absolute", top: "20px", right: "20px", background: "white", border: "1px solid #ccc", borderRadius: "50%", width: "36px", height: "36px", fontSize: "20px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#666", fontWeight: "bold", zIndex: 100000 }}
          >
            ×
          </button>

          <div
            onClick={(e) => e.stopPropagation()}
            style={{ width: "60vw", height: "80vh", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}
          >
            <div style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 2, padding: "16px 20px", borderBottom: "1px solid #ccc" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={{ margin: 0, color: "rgb(106, 106, 106)" }}>
                  Preview Question Paper
                  <span
                    style={{ marginLeft: "10px", cursor: "pointer", fontSize: "12px", textDecoration: "underline" }}
                    onClick={() => setShowOptions((prev) => !prev)}
                  >
                    {showOptions ? "Hide Options" : "Show Options"}
                  </span>
                </h3>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginTop: "10px", fontSize: "14px" }}>
                <div style={{ flex: "0 0 48%" }}>
                  <p style={{ marginBottom: "8px" }}><span>Question Paper:</span> {previewData.ques_paper_info?.ques_paper_name || selectedQuestionPaperName || "N/A"}</p>
                  <p><span>Course:</span> {selectedCourseName || "N/A"}</p>
                </div>
                <div style={{ flex: "0 0 48%" }}>
                  <p style={{ marginBottom: "8px" }}><span>Created By:</span> {selectedQuestionPaperCreatedBy || "N/A"}</p>
                  <p><span>Subjects:</span> {selectedQuestionPaperSubjects || "N/A"}</p>
                </div>
              </div>
            </div>

            <div style={{ overflowY: "auto", padding: "20px", flex: 1 }}>
              {previewData.subjects?.map((subject, subjIdx) => (
                <div key={subject.subject_superset_id || subjIdx} style={{ marginBottom: "24px" }}>
                  <h4 style={{ color: "#424242", marginBottom: "12px", padding: "8px 12px", textAlign: "left" }}>
                    {subject.subject_superset_name || `Subject ${subjIdx + 1}`}
                  </h4>

                  {subject.sections?.map((section, secIdx) => (
                    <div key={section.section_name || secIdx} style={{ marginBottom: "16px", paddingLeft: "12px" }}>
                      <h5 style={{ color: "rgb(106, 106, 106)", marginBottom: "18px", textAlign: "left" }}>
                        Section {section.section_name}
                      </h5>

                      {section.questions?.length > 0 ? (
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {section.questions.map((ques, qIdx) => (
                            <li key={ques.ques_id || qIdx} style={{ marginBottom: "16px", paddingLeft: "8px" }}>
                              <div style={{ marginBottom: "4px", fontSize: "14px", color: "#424242" }}>
                                {qIdx + 1}.{" "}
                                {(() => {
                                  const raw = ques.ques_text || ques.question_text || "";
                                  const decoded = he.decode(raw);
                                  const segments = decoded.split(/(imgsrc=[^\s]+)/g);
                                  return segments.map((seg, i) => {
                                    if (seg.startsWith("imgsrc=")) {
                                      const url = seg.replace("imgsrc=", "");
                                      return <img key={i} src={url} alt={`Q${qIdx + 1}`} style={{ maxHeight: "100px", width: "auto", margin: "5px", verticalAlign: "middle" }} />;
                                    }
                                    return <span key={i}><Latex>{seg}</Latex></span>;
                                  });
                                })()}
                              </div>

                              {showOptions && ques.options?.length > 0 && (
                                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingLeft: "20px", marginTop: "5px" }}>
                                  {[0, 1].map((col) => (
                                    <ul key={col} style={{ flex: "1 1 45%", paddingLeft: "20px", listStyleType: "disc" }}>
                                      {ques.options
                                        .filter((_, idx) => idx % 2 === col)
                                        .map((option, idx) => {
                                          const globalIndex = col + idx * 2;
                                          return (
                                            <li key={option.option_id || globalIndex} style={{ padding: "4px 0", fontSize: "13px", color: "#555" }}>
                                              {String.fromCharCode(65 + globalIndex).toLowerCase()}.{" "}
                                              {(() => {
                                                const raw = option.option_text || "";
                                                const decoded = he.decode(raw);
                                                const segments = decoded.split(/(imgsrc=[^\s]+)/g);
                                                return segments.map((seg, i) => {
                                                  if (seg.startsWith("imgsrc=")) {
                                                    const url = seg.replace("imgsrc=", "");
                                                    return <img key={i} src={url} alt="option" style={{ maxHeight: "80px", width: "auto", margin: "3px", verticalAlign: "middle" }} />;
                                                  }
                                                  return <span key={i}><Latex>{seg}</Latex></span>;
                                                });
                                              })()}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  ))}
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p style={{ color: "#999", fontSize: "13px" }}>No questions in this section.</p>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DPPSchedulingEdit;